module.exports = __webpack_public_path__ + "img/Retail23.b98de69a.png";